export default __webpack_public_path__ + "static/media/icon-info.65b4294f.svg";